import { render, staticRenderFns } from "./top-right.vue?vue&type=template&id=c9ed620c&scoped=true&"
import script from "./top-right.vue?vue&type=script&lang=js&"
export * from "./top-right.vue?vue&type=script&lang=js&"
import style0 from "./top-right.vue?vue&type=style&index=0&id=c9ed620c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ed620c",
  null
  
)

export default component.exports